import { storage } from '@/services/storage'
import Products from '@/views/products'
import ProductsConfigurations from '@/views/products/configurations'
import DigitalSign from '@/views/products/digital-sign'
import DigitalSignClickSign from '@/views/products/digital-sign/click-sign'
import DigitalSignDocuSign from '@/views/products/digital-sign/docu-sign'
import DigitalSignOnlineSign from '@/views/products/digital-sign/online-sign'
import ProductsList from '@/views/products/list'
import ProductsPermissions from '@/views/products/permissions'
import ProductDataUnits from '@/views/products/permissions/dataUnits'
import ProductsExclusiveUnits from '@/views/products/exclusiveUnits'
import Steps from '@/views/products/steps'
import StepFour from '@/views/products/steps/step-four'
import ProductsVisualization from '@/views/products/visualization'
import ProductsDeploymentImage from '@/views/products/visualization/deployment-image'
import ProductsDigitalMirror from '@/views/products/visualization/digital-mirror'
import UnitsHorizontal from '@/views/products/visualization/digital-mirror/components/units-horizontal'
import UnitsVertical from '@/views/products/visualization/digital-mirror/components/units-vertical'
import ProductUnits from '@/views/products/visualization/units'

let routes = [
    {
        path: '/empreendimentos',
        name: 'products',
        redirect: 'products.list',
        component: Products,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Empreendimentos',
            protect: true
        },
        children: [
            {
                path: '',
                name: 'products.list',
                component: ProductsList,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Lista de Empreendimentos',
                    protect: true
                }
            },
            {
                path: 'permissoes/dados-unidade/mensagem/:id?',
                name: 'products.dataUnits',
                component: ProductDataUnits,
                props: true,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Sem Permissão de Acesso',
                    protect: true
                }
            },
            {
                path: 'visualizar',
                name: 'products.visualization',
                component: ProductsVisualization,
                redirect: 'products.deploymentImage',
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Visualização de Empreendimentos',
                    protect: true
                },
                children: [
                    {
                        path: 'espelho-digital',
                        name: 'products.digitalMirror',
                        component: ProductsDigitalMirror,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Espelho Digital',
                            protect: true
                        },
                        children: [
                            {
                                path: 'vertical/:id',
                                name: 'products.unitsVertical',
                                component: UnitsVertical,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Espelho Digital Vertical',
                                    protect: true
                                }
                            },
                            {
                                path: 'horizontal/:id',
                                name: 'products.unitsHorizontal',
                                component: UnitsHorizontal,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Espelho Digital Horizontal',
                                    protect: true
                                }
                            }
                        ]
                    },
                    {
                        path: 'imagem-de-implantacao/:id',
                        name: 'products.deploymentImage',
                        component: ProductsDeploymentImage,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Imagem de Implantação',
                            protect: true
                        }
                    },
                    {
                        path: 'lista-de-unidades/:id',
                        name: 'products.units',
                        component: ProductUnits,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Lista de Unidades',
                            protect: true
                        }
                    },
                ]
            },
            {
                path: 'configuracoes/:id',
                name: 'products.configurations',
                component: ProductsConfigurations,
                props: true,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Configurações',
                    protect: true
                },
                children: [
                    {
                        path: 'permissoes',
                        name: 'products.permissions',
                        component: ProductsPermissions,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Permissões',
                            protect: true
                        },
                        props: true
                    },
                    {
                        path: 'assinatura-digital',
                        name: 'products.digitalSign',
                        component: DigitalSign,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Assinatura Digital',
                            protect: true
                        },
                        children: [
                            {
                                path: 'docu-sign',
                                name: 'products.digitalSign.docuSign',
                                component: DigitalSignDocuSign,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Assinatura Digital DocuSign',
                                    protect: true
                                }
                            },
                            {
                                path: 'click-sign',
                                name: 'products.digitalSign.clickSign',
                                component: DigitalSignClickSign,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Assinatura Digital ClickSign',
                                    protect: true
                                }
                            },
                            {
                                path: 'assine-online',
                                name: 'products.digitalSign.onlineSign',
                                component: DigitalSignOnlineSign,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Assinatura Digital Assine Online',
                                    protect: true
                                }
                            }
                        ]
                    },
                    {
                        path: 'unidades-exclusivas',
                        name: 'products.exclusiveUnits',
                        component: ProductsExclusiveUnits,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Unidades Exclusivas',
                            protect: true
                        },
                        props: true
                    },
                ]
            },
            {
                path: '',
                name: 'products.steps',
                component: Steps,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Etapas',
                    protect: true
                },
                children: [
                    {
                        path: 'etapa4/:id',
                        name: 'products.stepFour',
                        component: StepFour,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Etapa 4',
                            protect: true
                        }
                    }
                ]
            }
        ]
    },
]

export { routes }

